module.exports = __webpack_public_path__ + "img/banner.c6a76b44.png";